export interface TaxonomyTerm {
  termId: number;
  name: string;
  slug: string;
  taxonomy?: string;
  parentTermId?: number;
}

export interface TaxonomyOption {
  label: string;
  value: string;
}
